import { ChangeDetectionStrategy, Component, computed, inject, signal } from "@angular/core";
import { TranslocoDirective } from "@jsverse/transloco";
import { SelectAccountsPageComponent } from "@m19-board/onboarding/select-accounts-page.component";
import { AccountMarketplace } from "@front/m19-api-client";
import { IButtonDirective, MODAL_DATA, ModalRef } from "@front/m19-ui";
import { AccountSelectionService } from "@front/m19-services";
import { toSignal } from "@angular/core/rxjs-interop";
import { map } from "rxjs/operators";

@Component({
  selector: "app-data-warehouse-account-selection-modal",
  imports: [TranslocoDirective, SelectAccountsPageComponent, IButtonDirective],
  templateUrl: "./data-warehouse-account-selection-modal.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataWarehouseAccountSelectionModalComponent {
  protected readonly modalRef = inject(ModalRef);
  private readonly modalData = inject<AccountMarketplace[]>(MODAL_DATA);
  private readonly accountSelectionService = inject(AccountSelectionService);

  protected readonly isUpdating: boolean = this.modalData.length > 0;

  protected readonly accountGroups = toSignal(
    this.accountSelectionService.selectedOrganizationAccountGroups$.pipe(map((org) => org.accountGroups)),
    { requireSync: true },
  );
  protected readonly selectedOrganization = toSignal(this.accountSelectionService.selectedOrganizationAccountGroups$, {
    requireSync: true,
  });
  protected readonly selectedAccountMarketplaces = signal<AccountMarketplace[]>(this.modalData);
  protected availableAccountMarketplaces = computed(() => {
    return this.accountGroups()
      .map((accountGroup) => accountGroup.getAccountMarketplaces())
      .flat();
  });

  protected selectionChange(accountMarketplaces: AccountMarketplace[]) {
    this.selectedAccountMarketplaces.set(accountMarketplaces);
  }

  protected cancelSelection() {
    this.modalRef.close();
  }

  protected confirmSelection() {
    this.modalRef.close(this.selectedAccountMarketplaces());
  }
}
